import { VApp } from 'vuetify/lib/components/VApp';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[(_vm.settingHeader)?_c('ProfileAccountSettingHeader'):_vm._e(),_c('router-view'),_c('vue-progress-bar'),_c('AppAlertDialog'),_c('AppConfirmationDialog'),_c('AppSnackbar'),_c('AppUploadManager')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }